import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { customerPaymentLog, customerPaymentLogParams } from './customerPaymentLogs.types';

const getCustomerPaymentLogsList = (client: AxiosInstance) => async (params: customerPaymentLogParams) => {
  return (
    await client.get<PaginatedApiResponse<customerPaymentLog[]>>(API_ROUTES.GET_CUSTOMER_PAYMENT_LIST, { params })
  ).data;
};
export const customerPaymentQueries = {
  all: () => ['customer-payment-logs'],
  list: (params: customerPaymentLogParams) =>
    queryFactoryOptions<PaginatedApiResponse<customerPaymentLog[]>>({
      queryKey: [...customerPaymentQueries.all(), 'list', params],
      queryFn: (client) => () => getCustomerPaymentLogsList(client)(params),
    }),
};
